import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import { personFullName } from '../../../../../../services/Api';
import PropTypes from "prop-types";
import PermissionsAdmin from "./components/PermissionsAdmin";

class AdminUserDetail extends Component {

    static contextTypes = { api: PropTypes.object };

    state = {};


    didEditPerson = () => {
        this.context.api.people.refresh(this.props.person.id);
        this.setState({ addingPayment: false, editingPayment: false });
    };


    render() {

        if (!this.props.person) return null;

        return (
            <div className='PersonDetail'>
                <div className='detail-header'>
                    <h4>{personFullName(this.props.person)}</h4>
                </div>

                <br />

                <div className='clearfix'></div>


                {( window.security.isSuperAdmin()) ?
                    <PermissionsAdmin person={this.props.person} />
        : null}



            </div>
        );
    }
}

export default AdminUserDetail;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AdminUsers/components/AdminUserDetail/index.js